import React from 'react';

// Import types and constants from your project
import { QualificationGroup,  } from '../../types/schemas/abc';
import { qualificationOptions } from '../../types/schemas/subjectsandgrades'; // Adjust path

// Import the necessary styled components
import {
  QualificationsGrid,
  QualificationBox,
  BoxHeader,
  SubjectGradeRow,
  SubjectName,
  SubjectGrade,
  ScoreDisplay,
  MaxScoreDisplay,
  InfoRow,
  InfoLabel,
  InfoValue,
} from '../../styles/profile/form.style'; // Adjust path

// --- HELPER FUNCTION ---
const getQualificationMetadata = (type: string) => {
  for (const group of qualificationOptions) {
    const option = group.options.find(opt => opt.value === type);
    if (option) return option;
  }
  return null;
};

// --- COMPONENT PROPS ---
interface QualificationsDisplayProps {
  groups: QualificationGroup[];
}

// --- THE DEDICATED DISPLAY COMPONENT ---
const QualificationsDisplay: React.FC<QualificationsDisplayProps> = ({ groups }) => {
  if (!groups || groups.length === 0) {
    return (
      <InfoRow>
        <InfoLabel>Qualifications</InfoLabel>
        <InfoValue>Not Provided</InfoValue>
      </InfoRow>
    );
  }

  return (
    <QualificationsGrid>
      {groups.map(group => {
        const metadata = getQualificationMetadata(group.type);
        if (!metadata) return null;

        const isSubjectBased = metadata.format === 'subject-grade' || metadata.format === 'multi-component';

        return (
          <QualificationBox key={group.id}>
            <BoxHeader>{group.type}</BoxHeader>
            {isSubjectBased ? (
              <div>
                {(group.entries ?? []).map(entry => (
                  <SubjectGradeRow key={entry.id}>
                    <SubjectName>{entry.subject}</SubjectName>
                    <SubjectGrade>{entry.grade}</SubjectGrade>
                  </SubjectGradeRow>
                ))}
              </div>
            ) : (
              <ScoreDisplay>
                {group.score}
                {metadata.max && (
                  <MaxScoreDisplay>/ {metadata.max}</MaxScoreDisplay>
                )}
              </ScoreDisplay>
            )}
          </QualificationBox>
        );
      })}
    </QualificationsGrid>
  );
};

export default QualificationsDisplay;